import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompDateTimePickerWrapperCore } from '../core/forms/datetime-picker/wrapper'
import { CompDateTimePicker } from './CompDateTimePicker'

/**
 * CompDateTimePickerWrapper
 */
const CompDateTimePickerWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompDateTimePickerWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompDateTimePicker {...props} />}
    </CompDateTimePickerWrapperCore>
  )
}


export default CompDateTimePickerWrapper